'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentContainer = exports.ModalContent = exports.AlignedContainer = exports.SectionHeader = exports.ModalBody = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require('web-makeup/dist/design-system/config/data/theme');

var _style = require('../style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var ModalBody = exports.ModalBody = _styledComponents2.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var SectionHeader = exports.SectionHeader = _styledComponents2.default.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 18px;\n  line-height: 1.5rem;\n  font-weight: 900;\n  color: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n"], ["\n  font-size: 18px;\n  line-height: 1.5rem;\n  font-weight: 900;\n  color: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n"])), _style.COLOR_MIDNIGHT, function (_a) {
    var marginTop = _a.marginTop;
    return marginTop ? '1rem' : '0';
}, function (_a) {
    var lessBottomMargin = _a.lessBottomMargin;
    return lessBottomMargin ? '1rem' : '1.5rem';
});
var AlignedContainer = exports.AlignedContainer = _styledComponents2.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: ", ";\n"])), function (_a) {
    var centerAlign = _a.centerAlign;
    return centerAlign ? 'center' : 'flex-end';
});
var ModalContent = exports.ModalContent = _styledComponents2.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: 1px solid #", ";\n  padding: 1rem 1.75rem 1.25rem;\n  margin: 1.25rem 0;\n  text-align: left;\n"], ["\n  border: 1px solid #", ";\n  padding: 1rem 1.75rem 1.25rem;\n  margin: 1.25rem 0;\n  text-align: left;\n"])), _theme.colors.radagast);
var PaymentContainer = exports.PaymentContainer = _styledComponents2.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 1.25rem 1.75rem;\n  border-bottom: 1px solid ", ";\n\n  &:last-child {\n    border: none;\n    padding-bottom: 0;\n  }\n"], ["\n  padding: 1.25rem 1.75rem;\n  border-bottom: 1px solid ", ";\n\n  &:last-child {\n    border: none;\n    padding-bottom: 0;\n  }\n"])), _style.COLOR_GANDALF);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=InvoiceModal.style.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/InvoiceModal/InvoiceModal.style.js
// module id = 1953
// module chunks = 0